export default __webpack_public_path__ + "static/media/mailist.ac394867.jpg";